import { render, staticRenderFns } from "./DeleteDossier.vue?vue&type=template&id=7f85c8c1&"
import script from "./DeleteDossier.vue?vue&type=script&lang=ts&"
export * from "./DeleteDossier.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports